import { Box, Button, Collapse, Typography } from "@mui/material";
import { useQuery } from "react-query";
import StatsCard from "src/components/common/StatsCard";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import {
  getLandDashboardDetails,
  getTableDashboardDetails,
} from "src/utils/api/dashboard";
import defaultStyles, { StylesClasses } from "../styles";
import { getStyles } from "src/styles/theme";
import StatusBarChart from "src/components/common/StatusBarChart";
import {
  exportNewSelectedTableToXlsx,
  formatDataForBarChart,
} from "src/utils/helper";
import {
  NewSelectedDashBoardTable,
  NewSelectedTableProps,
} from "src/components/common/DashboardTable/newSelectedDashboard";
import { useState } from "react";
import { AxiosResponse } from "axios";
import DashboardTableSkeleton from "src/components/common/DashboardTableSkeleton";

const TOP_HEADERS = [
  "",
  "ALL INCL. DESELECT",
  "NEW SELECTED (ACTIVE)",
  "PROVISIONAL SELECTED",
  "SITE VISITED",
  "ACKNOWLEDGE BY APPROVER",
  "DESELECT",
];

const SUB_HEADERS = [
  "S.No",
  "State",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
];

const NewSelectedDashboard = () => {
  const [tableRows, setTableRows] = useState<any[]>([]);
  const [tableState, setTableState] = useState(false);
  const [isTabLoading, setIsTabLoading] = useState(true);

  const queryParams = { type: "newlySelected" };

  const { data: dashboard, isLoading: dashboardLoading } = useQuery(
    ["newSelectedLandDashboard"],
    () => getLandDashboardDetails(queryParams),
    {
      onSuccess: () => {},
      onError: () => {},
      refetchOnMount: true,
    }
  );

  const { isLoading } = useQuery(
    ["table-newlySelected"],
    () => getTableDashboardDetails(queryParams),
    {
      onSuccess: (res: AxiosResponse) => {
        setTableRows(
          res?.data?.stats.map((item: any, idx: number) => ({
            id: idx,
            sno: idx + 1,
            state: item.state,
            totalNumberAllIncludingDeselect:
              item.totalNumberAllIncludingDeselect,
            totalAreaAllIncludingDeselect: item.totalAreaAllIncludingDeselect,
            totalNumberNewSelected: item.totalNumberNewSelected,
            totalAreaNewSelected: item.totalAreaNewSelected,
            totalNumberProvisionalSelected: item.totalNumberProvisionalSelected,
            totalAreaProvisionalSelected: item.totalAreaProvisionalSelected,
            totalNumberSiteVisited: item.totalNumberSiteVisited,
            totalAreaSiteVisited: item.totalAreaSiteVisited,
            totalNumberAcknowledgeByApprover:
              item.totalNumberAcknowledgeByApprover,
            totalAreaAcknowledgeByApprover: item.totalAreaAcknowledgeByApprover,
            totalNumberDeselect: item.totalNumberDeselect,
            totalAreaDeselect: item.totalAreaDeselect,
          }))
        );
        setIsTabLoading(false);
      },
      onError: () => {},
      refetchOnMount: true,
    }
  );

  const dashboardTableData: NewSelectedTableProps = {
    topHeader: TOP_HEADERS,
    header: SUB_HEADERS,
    data: tableRows,
  };

  const styles = getStyles<StylesClasses>(defaultStyles);

  const formattedData = formatDataForBarChart(dashboard?.data?.stats);

  return (
    <>
      {dashboardLoading || isLoading || isTabLoading ? (
        <DashboardTableSkeleton />
      ) : (
        <>
          <Box {...styles("topHeader")}>
            <Box
              sx={{ width: "100%", marginBottom: "20px", alignSelf: "center" }}
            >
              <StatusBarChart
                data={formattedData}
                label={"Status of New Selected Land Blocks"}
              />
            </Box>

            <Box {...styles("statsCardWrapper")}>
              {dashboard?.data?.stats?.map((stat: any, index: number) => (
                <StatsCard
                  key={index}
                  title={`${stat?.description?.toUpperCase()}`}
                  value={`${stat?.number}`}
                  area={stat?.totalArea}
                  customStyles={{ valueCard: styles("statsCard").sx }}
                />
              ))}
            </Box>
          </Box>

          <Box {...styles("dashboardTableWrapper")}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h5">
                Status of New Selected Land Under GCP
              </Typography>
              <Button
                variant="outlined"
                onClick={() => setTableState(!tableState)}
              >
                {tableState ? (
                  <>
                    Compress
                    <ArrowUpwardIcon sx={{ marginLeft: "10px" }} />
                  </>
                ) : (
                  <>
                    Expand
                    <ArrowDownwardIcon sx={{ marginLeft: "10px" }} />
                  </>
                )}
              </Button>
            </Box>
            <Collapse in={tableState}>
              <Button
                variant="outlined"
                onClick={() =>
                  exportNewSelectedTableToXlsx(
                    dashboardTableData.data,
                    dashboardTableData.header,
                    dashboardTableData.topHeader
                  )
                }
                sx={{ float: "right", marginBottom: "20px" }}
              >
                Export
              </Button>
              <NewSelectedDashBoardTable {...dashboardTableData} />
            </Collapse>
          </Box>
        </>
      )}
    </>
  );
};

export default NewSelectedDashboard;
